import React from "react";

// single fact item
function SingleFactItem({ count, meta }) {
  return (
    <div className="col-lg-3 col-md-4 col-sm-6">
      <div className="fact__item text-center">
        <h2 className="fact__count">{count}</h2>
        <span className="meta">{meta}</span>
      </div>
    </div>
  )
}

const FactAreaThree = () => {
  return (
    <section className="fact-area fact-style-three section-pt-60 section-pb-30">
      <div className="container">
        <div className="fact__items-wrap position-relative">
          

          

          <div
            className="row justify-content-center"
            data-anime="targets: > *; opacity:[0, 1]; scale:[0.5, 1]; onview: -250; delay: anime.stagger(100);"
          >
            <SingleFactItem count="125 M" meta="Staking" />
            <SingleFactItem count="125 M" meta="Locker" />
            <SingleFactItem count="125 M" meta="Liquidity" />
            <SingleFactItem count="25 M" meta="Marketing" />
            <SingleFactItem count="25 M" meta="Team" />
            <SingleFactItem count="25 M" meta="Listing" />
            <SingleFactItem count="25 M" meta="Airdrops" />
            <SingleFactItem count="25 M" meta="Burning" />

          </div>
        </div>
      </div>
    </section>
  )
}

export default FactAreaThree
